import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const JobPrice = ({
  jobPrice = '$0.00',
  id,
}: {
  jobPrice?: string;
  id: string;
}) => {
  const { t } = useTranslations(translations);
  const jobPriceWithFraction = `$${Number(
    jobPrice.replace(/[$,]/g, ''),
  ).toFixed(2)}`;

  return (
    <Text id={id}>
      {jobPriceWithFraction &&
        t('job-price-tax-code', { jobPriceWithFraction })}
    </Text>
  );
};
